<template>
  <!-- set-company-info .ech -->
  <div>
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>企业中心</BreadcrumbItem>
          <BreadcrumbItem>分享设置</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.name}}</div>
      </div>
    </div>
    <div class="layout-content">
      <Row style="padding:  142px 0 142px 40px;">
        <Col span="12">
          <Form ref="formValidate" :model="formValidate" :rules="ruleInline" :label-width="100">
            <FormItem label="分享标题：" prop="title">
              <Input v-model="formValidate.title" placeholder="我是XXX，我是第N位分享的人，你也一起来吧！" />
            </FormItem>
            <FormItem label="分享图片：">
              <div class="my-upload">
                <div
                  class="my-upload-list"
                  v-for="(item, index) in uploadList"
                  :key="'upload' + index"
                >
                  <template v-if="item.status === 'finished'">
                    <img :src="item.url" style="width: 100px;height:100px;" />
                    <div class="my-upload-list-cover">
                      <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                      <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
                    </div>
                  </template>
                  <template v-else>
                    <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
                      <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                    </Spin>
                  </template>
                </div>
                <Upload
                  ref="upload"
                  :show-upload-list="false"
                  :default-file-list="defaultList"
                  :on-success="handleSuccess"
                  :format="['jpg','jpeg','png']"
                  :max-size="2048"
                  :headers="formHeaders"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  type="drag"
                  :action="uploadUrl"
                  multiple
                  :before-upload="handleBeforeUpload"
                  style="display: inline-block;width: 100px;"
                  v-show="uploadList && uploadList.length <1"
                >
                  <div style="width: 100px;height:100px;padding-top: 17px;">
                    <div style="font-size:20px">
                      +
                      <p style="font-size:14px">上传</p>
                    </div>
                  </div>
                  <!-- 蒙版 -->
                  <div
                    style="position:absolute;opacity:0;width:100px;height:100px;left:0;top:0;"
                    @click.stop="selectType"
                  ></div>
                </Upload>
              </div>
              <div class="my-upload-tip">（图片要求：2M以下的jpg或png，建议图片尺寸500X500px）</div>
            </FormItem>
            <FormItem>
              <Button
                size="large"
                type="primary"
                :loading="loading"
                @click="handleSubmit('formValidate')"
              >保存</Button>
            </FormItem>
          </Form>
        </Col>
        <Col span="8">
          <div class="iphone-share f-tar">
            <img style="width:auto;height:386px;" src="@assets/img/iphone-share.png" />
          </div>
        </Col>
      </Row>
    </div>
    <!-- 选择文件上传方式 -->
    <imgUpload
      @upload:local="uploadLocal"
      @upload:material="uploadMaterial"
      :maxCount="1"
      v-model="uploadChooseShowed"
    />

    <iModal title="预览" cancel-text v-model="visible" @on-cancel="hideView">
      <div style="text-align: center;">
        <img :src="viewImg" v-if="viewImg" style="max-width: 100%" />
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import imgUpload from "@components/imgUpload/imgUpload.vue";
export default {
  name: "company-share",
  data() {
    return {
      viewImg: "",
      visible: false,
      loading: false,
      showModal: false,
      formValidate: {
        title: ""
      },
      ruleInline: {
        // 效验规则
        title: [
          { required: true, message: "分享标题不能为空", trigger: "blur" },

          {
            type: "string",
            max: 28,
            message: "分享标题不能大于28位",
            trigger: "blur"
          }
        ]
      },
      defaultList: [],
      uploadList: [],
      limitNum1: 1, // 图文显示的限制图片个数
      uploadChooseShowed: false, // 控制文件上传方式的显示和隐藏
      exData: null
    };
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany", 
      exhibition: "loginModule/getExhibition",
      joinInfo: "loginModule/getJoinInfo",
    }),
    option() {
      return {
        CompId: this.company.id,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "exhibitionId",
                  Value: this.exhibition.id
                }
              }
            ]
          }
        }
      };
    }
  },
  mounted() {
    this.uploadList = this.$refs.upload.fileList;
    this.setData();
  }, 
  components: {
    imgUpload
  },
  methods: {
    ...mapMutations({
      setExhibition: "loginModule/setExhibition",
      setCompany: "loginModule/setCompany",
    }),
    ...mapActions({
      getByCompany: "exhibitionModule/getByCompany",
      putJoinExhibitionInfo: "exhibitionModule/putJoinExhibitionInfo",
      editCompanyUpdate: "companyModule/editCompanyUpdate",
      getCompanyById: "loginModule/getCompanyById",
    }),
    setData() {   
      let shareInfo = this.company.shareInfo
        ? JSON.parse(this.company.shareInfo)
        : { Title: "", Cover: "" };
      this.formValidate.title = shareInfo.Title || '';
      if (shareInfo.Cover) {
        this.defaultList = [
          {
            name: this.company.name,
            url: shareInfo.Cover,
            status: "finished",
            percentage: 100
          }
        ];
      } 
      this.uploadList = this.defaultList;
    },
    // 上传成功
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    // 文件格式错误
    handleFormatError(file) {
      this.$Message.warning(`文件格式是不正确的, 请上传jpg或者png格式的图片`);
    },
    // 文件过大
    handleMaxSize(file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于2M的图片`);
    },
    // 上传数量
    handleBeforeUpload() {
      const limitNum1 = 1;
      const check1 = this.uploadList.length < limitNum1;
      if (!check1) {
        this.$Message.warning(`最多上传${limitNum1}张图片`);
      }
      return check1;
    },
    // 移除上传图片
    handleRemove(file) {
      const fileList1 = this.uploadList;
      this.uploadList.splice(fileList1.indexOf(file), 1);
    },
    // 查看上传图片
    handleView(name) {
      this.visible = true;
      this.viewImg = name;
    },
    hideView(name) {
      this.visible = false;
      this.viewImg = '';
    },
    // 活动发布
    async handleSubmit(name) {
      let imgList1 = this.transfromImgList(this.uploadList);
      let valid = await this.validForm(name);
      if (!valid) return;
      if (!(this.uploadList && this.uploadList.length)) {
        this.$Message.error(`请上传分享图片`);
        return;
      }
      let formData = {
        ExhibitonId: this.exhibition.id,
        JoinId: this.joinInfo.joinId,
        CommandId: 2,
        Id: this.company.id,
        SetValues: {
          ShareInfo:{
            Title: this.formValidate.title,
            Cover: this.uploadList[0].url
          }
        }
      }; 
      this.loading = true;
      setTimeout(c => {
        this.loading = false;
      }, 5000);
      let bool = await this.editCompanyUpdate(formData).catch(
        e => (this.loading = false)
      );
      let data = await this.getCompanyById(this.company.id);
      if (data) {
        this.setCompany(data);
      }
      this.loading = false;
      if (bool.successed) {
        this.$Message.success("保存成功");
      } else {
        this.$Message.error("保存失败，请重新尝试");
      }
    },
    async getExInfo() {
      if (this.exData) {
        let exData = await this.getExhibitionById(this.exData.exhibitionId);
        this.setExhibition(exData);
      }
    },
    // 验证表单
    validForm(name) {
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    transfromImgList(arr) {
      let arr2 = [];
      arr.forEach(c => {
        arr2.push(c.url);
      });
      return arr2;
    },
    close() {
      this.loading = false;
      if (this.$refs["formValidate"]) {
        this.$refs["formValidate"].resetFields();
        this.formValidate.outLinkdes = "";
      }
      this.defaultList = [];
      this.uploadList = [];
      if (this.$refs["upload"]) this.$refs["upload"].clearFiles();
      this.$emit("close");
    },
    // 选择图片上传方式
    selectType() {
      this.uploadChooseShowed = true;
    },
    // 拦截上传方法
    uploadLocal() {
      this.$refs.upload.handleClick();
    },
    // 接收素材库上传的文件
    uploadMaterial(e) {
      for (let item of e) {
        if (this.uploadList.length >= 1) {
          this.$Message.warning(`最多上传1张图片`);
          return;
        } else {
          this.uploadList.push({
            status: "finished",
            url: item
          });
          this.uploadChooseShowed = false;
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
</style>


